// meranie do GA4 [virtualky, quickbet, matchtracker, page title pre pridanie odd na ticket]
communication.dataTrackModule = {
    // pomocna funkcia pre odchytenie elementu a jeho child elementov a textu v nich - az po ich vykresleni 
    waitForElementReady: function (elementSelector, timeout = 5000, interval = 500) {
        return new Promise((resolve, reject) => {
            const intervalId = setInterval(() => {
                const element = document.querySelector(elementSelector);
                if (element) {
                    clearInterval(intervalId);
                    resolve(element);
                } else if (timeout <= 0) {
                    clearInterval(intervalId);
                    reject(resolve(null));
                }
                timeout -= interval;
            }, interval);
        });
    },

    // listener na klikanie na elementy pre trackovanie. 
    // Maju atribut data-track. Idealne je ho dat na parent element kde su info o tom, co chceme trackovat
    mouseEvListener: document.addEventListener("mousedown", function (ev) {
        var el = ev.target.closest('[data-track]');
        
        if (el) {
            // trackovanie hier virtualne hry, matchtracker, quickbety
            if (['vg','mt','qb'].includes(el.dataset.track)) {
                communication.dataTrackModule.track.bettingGame(el);
            }

            // trackovanie klikania na tlacidla v spodnej liste
            if (el.closest('#footer')) {
                communication.dataTrackModule.track.footerButtons(el);
            }
        }
    }),

    // funkcie pre samotne zaznamenanie do GA4
    track: {
        // trackovanie hier
        bettingGame: function (el) {
            let vgName = '';
            switch (el.dataset.track) {
                // virtualne hry
                case "vg":
                    communication.dataTrackModule.waitForElementReady('.virtual-sport-active:not(.ui-collapsible-collapsed)').then(element => {
                        if (element) {
                            vgName += element.querySelector('.virtual-provider:has(.virtual-league-active) .provider-name-label').innerText + ' - ';
                            vgName += element.querySelector('.virtual-sport-active .vg-sport-title').innerText + ' - ';
                            vgName += element.querySelector('.virtual-league-active .league-name').innerText;
                            communication.dataTrackModule.track.video_start('virtuals', vgName);
                        }
                    });
                    break;
                // matchtracker v Live
                case "mt":
                    vgName = `Sportradar - ${el.dataset.trackLabel}`;
                    communication.dataTrackModule.track.video_start('matchtracker', vgName);
                    break;
                // Quickbety
                case "qb":
                    vgName = `Sportradar - STOLNÝ TENIS`;
                    communication.dataTrackModule.track.video_start('quickbets', vgName);
                    break;
            
                default:
                    break;
            };
        },
        // trackovanie tlacidiel vo footer - podla link_id vieme zjednotit button_text v roznych jazykoch
        footerButtons: function (el) {
            var button_text = "footer: " + el.innerText.replace("\n", " ");
            gtag('event', 'footer_button_click', {'link_text': button_text, 'link_id': el.id});
        },
        // GA4 - trackovanie ukoncenia sledovania videa matchtracker/virtualky/quickbet
        video_end: function (key, data) {
            try {
                switch (key) {
                    case 'virtualsEvona':
                    case 'virtuals':
                    case 'matchTracker':
                        // 
                        if (data.screenShow === false) {
                            communication.dataTrackModule.track.video_stop();
                        }
                    case 'quickbet':
                        if (data.token === false) {
                            communication.dataTrackModule.track.video_stop();
                        }
                        break;
                    default:
                        break;
                }
            } catch (error) {
                console.error(error);
            }
        },
        // Zaciatok sledovania videa
        video_start: function (key, vgName) {
            // osetrenie prepnutia videa virtualok
            if (rfs.videoPlayback?.gtag_event_attributes?.video_current_time > 0) {
                communication.dataTrackModule.track.video_stop();
            }
            rfs.videoPlayback.gtag_event_attributes = {
                'video_provider': key,
                'video_title': vgName,
                'video_current_time': 0
            };
            // Sledovanie casu prehravania 
            rfs.videoPlayback.timer = setInterval(function() {
                rfs.videoPlayback.gtag_event_attributes.video_current_time++;
            } , 1000);
            gtag('event', 'video_start', rfs.videoPlayback.gtag_event_attributes);
        },
        // Koniec sledovania videa
        video_stop: function () {
            if (rfs.videoPlayback?.gtag_event_attributes?.video_current_time > 0) {
                gtag('event', 'video_complete', rfs.videoPlayback.gtag_event_attributes);
                rfs.videoPlayback.gtag_event_attributes = {
                    'video_provider': false,
                    'video_title': false,
                    'video_current_time': 0
                }
                clearInterval(rfs.videoPlayback.timer);
                rfs.videoPlayback.timer = null;
            }
        },
        //GA logika identity hraca, aby sa nemiesala s business logikou player modulu.
        playerIdentity: function (opts) {
            try {
                if (typeof gtag !== "function") {
                    return;
                }

                // Flagy oddeluju realny prechod identity od beznych refreshov dat.
                var hasFreshLogout = Boolean(opts?.hasFreshLogout);
                var hasFreshLogin = Boolean(opts?.hasFreshLogin);
                // playerId je aktualny stav appky, reportedPlayerId je surova hodnota z payloadu.
                var playerId = opts?.playerId;
                var reportedPlayerId = Number(opts?.reportedPlayerId);
                // OTL hint je docasny, aby sa jednorazove odomknutie dalo odlisit od bezneho loginu.
                var pendingOneTimeLogin = Boolean(opts?.pendingOneTimeLogin);
                var loginMethod = opts?.loginMethod;
                var isManualVerifiedPlayer = Boolean(playerId && playerId === profile?.ManualVerifiedPlayerID);
                // user_id posielame iba pre realneho hraca, inak by sa miesali identity v GA.
                var gaUserId = hasFreshLogout
                    ? null
                    : ((playerId && playerId > 0 && playerId !== profile?.ManualVerifiedPlayerID)
                        ? String(playerId)
                        : undefined);
                // Specialne stavy drzia klasifikaciu konzistentnu aj ked backend vrati 0 alebo manual ID.
                var isClubPlayerZero = !Number.isNaN(reportedPlayerId) && reportedPlayerId === 0;
                var isManualVerifiedByReportedId = !Number.isNaN(reportedPlayerId) && reportedPlayerId === Number(profile?.ManualVerifiedPlayerID);
                var playerIdentityType = null;

                if (!hasFreshLogout) {
                    if (isClubPlayerZero) {
                        playerIdentityType = "gaming_club_player";
                    } else if (isManualVerifiedPlayer || isManualVerifiedByReportedId) {
                        playerIdentityType = "manual_verified_player";
                    } else if (pendingOneTimeLogin && gaUserId) {
                        playerIdentityType = "one_time_login_player";
                    } else if (gaUserId) {
                        playerIdentityType = "registered_player";
                    }
                }

                // user_id drzime cisty, manualne overene ID posielame iba ako user property.
                gtag('set', {'user_id': gaUserId});
                // user property player_identity_type je stale, aby sa dalo filtrovat v reportoch a segmentoch.
                gtag('set', 'user_properties', {
                    'player_identity_type': playerIdentityType
                });

                // Login event posielame iba pri realnom prihlaseni pod vlastnym ID (>0).
                if (hasFreshLogin && gaUserId) {
                    gtag('event', 'login', {'method': loginMethod || 'neznama'});
                }
            } catch (error) {
                console.error(error);
            }
        }
    },

    // Default screen title pre screen_view a zaklad pre zmenu title pre GA4 eventy
    screenTitle: function () {
        return "DOXXbet SportBox Client - " + offer.page;
    },

    // Zmena page title pre GA4 eventy - meni sa po klikani v menu a na filtre
    setScreenPath: function (index, path) {
        try {
            // osetrenie pri starte
            if (typeof offer != "object") return;
            if (typeof stored != "object") return;
            // nastavujem alebo mazem cestu v page title pre GA4 eventy
            switch (index) {
                case 0: // prva uroven v menu
                    if (offer.sportID*1 > -1 && path.length) { // ak je vybrany sport a nie je prazdny nazov
                        stored.screenPath = [path];
                    } else if (offer.sportID == -1) { // ak nie je vybrany sport
                        stored.screenPath = [];
                    } else {
                        return false;
                    }
                    break;
                case 1: // druha uroven v menu
                    if (offer.regionID*1 > -1 && path.length) { // ak je vybrany region a nie je prazdny nazov
                        stored.screenPath[index] = path;
                        stored.screenPath.splice(index + 1);
                    } else if (offer.regionID == -1) { // ak nie je vybrany region
                        stored.screenPath.splice(index);
                    } else {
                        return false;
                    }
                    break;
                case 2: // tretia uroven v menu
                    if (offer.leagueCupID*1 > -1 && path.length) { // ak je vybrana liga a nie je prazdny nazov
                        stored.screenPath[index] = path;
                        stored.screenPath.splice(index + 1);
                    } else if (offer.leagueCupID == -1) { // ak nie je vybrana liga
                        stored.screenPath.splice(index);
                    } else {
                        return false;
                    }
                    break;
                default:
                    break;
            }
            var screenPathText = stored.screenPath.filter((p) => p.length > 0).join(" | "); // ocistenie cesty od prazdnych stringov a spojenie do jedneho stringu
            communication.dataTrackModule.setTitle(screenPathText, stored.screenFilter);
        } catch (error) {
            console.error(error);
        }
    },

    setTitle: function (path, filter) {
        var newTitle = `${communication.dataTrackModule.screenTitle()}${filter ? " | " + filter : ""}${path ? " | " + path : ""}`;
        if (document.title != newTitle) {
            document.getElementsByTagName("title")[0].innerHTML = newTitle;
            stored.documentTitle = newTitle;
        }
    }
};

// GA4 - predefinovanie browser default gettera a settera pre document.title
Object.defineProperty(document, 'title', {
    set: function (newValue) {
        return; // jQuery mobile meni title pri otvarani a zatvarani modal, manipuloje history object ale nespravne - to nechceme
    },
    get: function () {
        return document.getElementsByTagName("title")[0].innerHTML; // toto je default getter
    }
});
